module.exports = __webpack_public_path__ + "img/example-bank.fcdbb52b.svg";